import { axiosInstance } from "../../../util/axios";
import { cncBaseUrlSelector, getCncAuthToken } from "../../../Api/ApiHelper";
import { formatWithPlaceholders } from "../../../util/utils";

export const cncFetchWOStatus = ({ woNo }) => {
  const baseUrl = cncBaseUrlSelector();
  const url = formatWithPlaceholders(
    `${baseUrl}${process.env.REACT_APP_CC_FETCH_WO_STATUS_API_PATH}`,
    woNo
  );
  return axiosInstance.get(url, {
    headers: {
      Authorization: `Bearer ${getCncAuthToken()}`,
      Accept: "application/json",
    },
  });
};
